import React, { useState, useEffect } from "react";
import "../ShiftTask/ShiftTask.css";
import "react-calendar/dist/Calendar.css";
import axios from "axios";
import { currentCareSiteId } from "../../redux-toolkit/reducer/switchSites";
import { Modal } from "react-bootstrap";
import { BsSearch } from "react-icons/bs";
import Select from "react-select";
import {
  ShiftTaskStatus,
  taskCtgImages,
  taskStatusColors,
} from "../../constants/constants";
import "./CreateShiftTask.css";
import DatePicker from "react-datepicker";
import {
  convertTimeToUserTimeZone,
  convertToTimeZone,
  convertToTimeZoneFullTime,
  extractTimeFromTimestamp,
  formatDate,
  getFullName,
  getMondayDate,
  getMonthAgoDate,
  removeTFromDate,
} from "../../utils/CommonFunctions";
import { httpAdmin } from "../../Apis/commonApis";
import {
  Switch,
  Route,
  NavLink,
  useRouteMatch,
  useLocation,
  useHistory,
} from "react-router-dom";
import RotaRoutes from "./RotaRouter";
import { ShowSwal } from "../../utils/alertSwal";
import moment from "moment";
import { useSelector } from "react-redux";

let monthAgoDate = getMonthAgoDate();

function Shift() {
  const history = useHistory();
  let { path, url } = useRouteMatch();
  const location = useLocation();

  const { currentCareSiteData, socketReloadCount } = useSelector(
    (state) => state.caresiteDataReducer
  );

  const [rowData, setRowData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [reloadData, setReloadData] = useState(0);
  const [filterType, setFilterType] = useState("week");
  const [dateRange, setDateRange] = useState([monthAgoDate, new Date()]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (location.state) {
      let fType = location.state.filterType;
      setFilterType(fType);
      if (fType === "custom") {
        setDateRange(location.state.dateRange);
      }
      handleNavigate("task-status");
    } else {
      let pathname = window?.location?.pathname;
      if (pathname?.includes("task-status") || pathname?.includes("schedule")) {
      } else {
        handleNavigate("schedule");
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (currentCareSiteData) {
      if (filterType === "custom" && endDate) {
        getShiftsandtaskData(formatDate(startDate), formatDate(endDate));
      } else if (filterType === "week") {
        let mondayDate = getMondayDate(new Date());
        getShiftsandtaskData(formatDate(mondayDate), formatDate(new Date()));
      }
    }
  }, [
    filterType,
    dateRange,
    socketReloadCount,
    reloadData,
    currentCareSiteData,
  ]);

  const getShiftsandtaskData = (start, end) => {
    let filterValue = "all";
    if (location.state) {
      filterValue = location.state.filter;
    }
    axios({
      url: `${process.env.REACT_APP_BASEURL}/getShiftsandtaskNew?careHomeId=${currentCareSiteId}&startDate=${start}&endDate=${end}&filter=${filterValue}`,
      method: "GET",
      headers: { Authorization: localStorage.getItem("care_admin_token") },
    })
      .then((res) => {
        const resData = res.data;
        // if (currentCareSiteData?.carefacility === "facalities") {
        //   handleGetShiftFacilityData(resData);
        // } else if (currentCareSiteData?.carefacility === "agency") {
        // }
        handleGetShiftAgencyData(resData);
      })
      .catch((error) => console.log(`Error: ${error}`));
  };

  function handleGetShiftAgencyData(allData) {
    const clientData = allData?.clients;

    let tasksArr = [];
    let checkInOutArr = [];
    const filterDeletedClient = clientData.filter(
      (item) => item.clientStatus !== "deleted"
    );
    filterDeletedClient?.forEach((client) => {
      let clientId = client?._id;
      const clientName = getFullName(client);
      const shiftDataForClient = allData?.shiftData?.filter((item) =>
        item.shiftMappings.some((elem) => elem.clientId?.includes(client?._id))
      );

      console.log(clientName, shiftDataForClient, 'shiftDataForClient')

      // Clock IN and Clock Out Task Passing to Task Array
      shiftDataForClient?.map((shiftItem, index) => {
        let shiftTimeZone = shiftItem?.timeZone;
        let shiftStartTime = `${
          shiftItem?.startingTime
          // convertTimeToUserTimeZone(shiftItem?.startingTime, shiftTimeZone) ??"--"
        }`;
        let shiftEndTime = `${
          shiftItem?.endingTime
          // convertTimeToUserTimeZone(shiftItem?.endingTime, shiftTimeZone) ??"--"
        }`;
        /* @field filterAssignedShifts
         * is used for no showing unassigned and open shifts
         * if the shiftItem.recurringShiftType param is coming "unassinged" or "open"*/
        let filterAssignedShifts = false;
        if (shiftItem?.recurringShiftType == "unassigned")
          filterAssignedShifts = false;
        else if (shiftItem?.recurringShiftType == "open")
          filterAssignedShifts = true;
        else filterAssignedShifts = true;

        if (filterAssignedShifts && shiftItem) {
          // const combinedDateTime = moment(
          //   `${shiftItem?.Date} ${shiftItem?.startingTime}:00`,
          //   "YYYY-MM-DD HH:mm:ss"
          // )
          //   .tz(shiftItem?.timeZone || "Asia/Calcutta")
          //   .format();

          if (shiftItem?.status
            // shiftItem?.status === "In-Process" ||
            // shiftItem?.status === "Done"
          ) {
            const filterShiftMappingByClient = shiftItem.shiftMappings.filter(
              (mapObj) => mapObj.clientId?.includes(clientId)
            );
            filterShiftMappingByClient?.forEach((mapObj, mIndex) => {
              if (mapObj?.checkinDateTime) {
                checkInOutArr.push({
                  _id: mapObj._id,
                  id: `${clientId}${mapObj?._id}${mIndex}checkinDateTime`,
                  clientName: clientName,
                  clientId,
                  RiskProfile: "",
                  TaskType: "/admin/images/s11.svg",
                  Task: "Clock-In",
                  careteamName: getFullName(mapObj.careteam),
                  notes: "notes",
                  shiftPeriod: `${shiftItem?.startingTime} - ${shiftItem?.endingTime}`,
                  taskTime: shiftStartTime,
                  timeDone: extractTimeFromTimestamp(
                    mapObj.checkinDateTime,
                    currentCareSiteData?.timeZone
                  ),
                  taskStatus: "Completed",
                  bgColor: "green",
                  shiftId: mapObj.shiftId,
                  date: shiftItem?.Date,
                  dateToShort: convertToTimeZoneFullTime(
                    mapObj.checkinDateTime
                  ),
                  description: "-",
                  observations: "-",
                  checkoutByPerson: mapObj?.checkoutByPerson,
                });
              }
              if (mapObj?.checkoutDateTime) {
                let checkoutPlace = mapObj?.checkoutPlace
                  ? `(${mapObj?.checkoutPlace})`
                  : "";
                let checkoutStatus =
                  mapObj.checkoutBy === "careTeamMember" ||
                  mapObj.checkoutBy === "admin"
                    ? "Clock-Out(Manual)"
                    : `Clock-Out(Auto)${checkoutPlace}`;
                checkInOutArr.push({
                  _id: mapObj._id,
                  id: `${clientId}${mapObj?._id}${mIndex}checkoutDateTime`,
                  clientName: clientName,
                  clientId,
                  RiskProfile: "",
                  TaskType: "/admin/images/s11.svg",
                  Task: checkoutStatus,
                  checkoutStatus: checkoutStatus,
                  careteamName: getFullName(mapObj.careteam),
                  notes: "notes",
                  shiftPeriod: `${shiftItem?.startingTime} - ${shiftItem?.endingTime}`,
                  taskTime: shiftEndTime,
                  timeDone: extractTimeFromTimestamp(
                    mapObj.checkoutDateTime,
                    currentCareSiteData?.timeZone
                  ),
                  taskStatus: "Completed",
                  bgColor: "green",
                  shiftId: mapObj.shiftId,
                  date: shiftItem?.Date,
                  dateToShort: convertToTimeZoneFullTime(
                    mapObj.checkoutDateTime
                  ),
                  description: "-",
                  observations: "-",
                  checkoutByPerson: mapObj?.checkoutByPerson,
                });
              }
            });
          }
        }
      });

      // Notamal Tasks Passing to Task Array
      const uniqueShiftByDate = uniqueByDate(shiftDataForClient);
      uniqueShiftByDate?.map((shiftItem, index) => {
        const shiftTaskList = allData.tasks?.filter(
          (item) =>
            item.clientId === client._id &&
            item.shiftDate?.split("T")?.[0] === shiftItem.Date
        );
        let shiftTimeZone = shiftItem?.timeZone;
        /* @field filterAssignedShifts
         * is used for no showing unassigned and open shifts
         * if the shiftItem.recurringShiftType param is coming "unassinged" or "open"*/
        let filterAssignedShifts = true;
        // if (shiftItem?.recurringShiftType == "unassigned")
        //   filterAssignedShifts = false;
        // else if (shiftItem?.recurringShiftType == "open")
        //   filterAssignedShifts = true;
        // else filterAssignedShifts = true;

        // Wellbeing Task In Every Shift
        if (filterAssignedShifts && shiftItem) {
          shiftTaskList?.forEach((task, taskIndex) => {
            const globalTask = task.globalTask;
            // const taskDoneBy = shiftItem?.shiftMappings?.find(
            //   (sObj) => sObj.careTeamId === task.doneBy
            // );
            const careteamName = task?.doneBy?._id
              ? getFullName(task.doneBy)
              : "";
            let taskDoneShiftPeriod = "--:--";
            let bgColor = "";
            let taskStatus = "";
            let timeOfTask = "";
            let taskStartTime = "";
            let taskEndTime = "";
            const taskComment = globalTask?.comments ?? task?.comments ?? "";
            let taskDescription =
              task?.reason && task?.status === "omitted"
                ? `${task?.reason}${taskComment ? "," : ""} ${taskComment}`
                : taskComment;
            let taskObservation = "";
            const taskDoneTime =
              (task?.status === "true" || task.status === "omitted") &&
              task?.timestamp
                ? extractTimeFromTimestamp(
                    task?.timestamp,
                    currentCareSiteData?.timeZone
                  )
                : "--:--";

            if (globalTask?.taskType === "BP") {
              taskObservation = task.input
                ? ` ${task.input?.Systolic_BP?.measureValue || "-"} / ${
                    task.input?.Diastolic_BP?.measureValue || "-"
                  } ${task.input?.Diastolic_BP?.measureType}`
                : "-";
            } else {
              taskObservation =
                task.input && task.input?.measureValue !== ""
                  ? ` ${task.input?.measureValue || "-"} ${
                      task.input?.measureType
                    }`
                  : "-";
            }
            if (globalTask?.shiftType?.includes("specific")) {
              taskStartTime = `${
                globalTask?.startTime
                // convertTimeToUserTimeZone(
                //   globalTask?.startTime,
                //   shiftTimeZone
                // ) ?? "--"
              }`;
              taskEndTime = `${
                globalTask?.endTime
                // convertTimeToUserTimeZone(globalTask?.endTime, shiftTimeZone) ??
                // "--"
              }`;
              timeOfTask = shiftItem.startTime ?? shiftItem?.startingTime;
            } else {
              timeOfTask = shiftItem?.startingTime;
            }
            if (
              (task.status === "true" || task.status === "omitted") &&
              task.shiftId
            ) {
              const shiftOfCompletedTask = shiftDataForClient.find(
                (sItem) => sItem._id === task.shiftId
              );
              taskDoneShiftPeriod = `${
                shiftOfCompletedTask?.startingTime ?? "--"
              } - ${shiftOfCompletedTask?.endingTime ?? "--"}`;
            }

            const taskDate = task.shiftDate
              ? removeTFromDate(task.shiftDate)
              : shiftItem?.Date;
            const combinedDateTime = moment(
              `${taskDate} ${timeOfTask}:00`,
              "YYYY-MM-DD HH:mm:ss"
            )
              .tz(shiftItem?.timeZone || "Asia/Calcutta")
              .format();
            const taskName = taskCtgImages.filter((i) =>
              globalTask?.taskName?.includes(i.Ctg)
            );
            let riskprofile = globalTask?.riskProfileCategory ?? "";
            let taskStatusObj =
              taskStatusColors.find((elem) => elem.status === task?.status) ??
              taskStatusColors[0];
            bgColor = taskStatusObj?.bgColor;
            taskStatus = taskStatusObj?.name;
            const isWellbeing =
              task.taskCategory === "wellbeing" ||
              task?.taskType === "wellbeing";
            /* *  if task is medication reminder then below status will be in task status
             *  'true' || 'false' || prn || self || assisted || assigned || overdue  || In-Process || omitted*/
            /* if task is except medication reminder then below status will be in task status
               'true' means completed || 'false' means pending || overdue ||  In-Process || omitted */
            if (globalTask?.medName) {
              let medImage = "";
              let Task = "";
              if (globalTask?.prn && globalTask?.prn === "Yes") {
                medImage = "/admin/images/s6.svg";
                Task = "PRN Med";
              } else {
                medImage = "/admin/images/s10.svg";
                Task = "Medication Reminder";
              }
              let medTaskObj = {
                _id: task?._id,
                id: `${task?._id}${index}_${taskIndex}medtask`,
                clientName: clientName,
                clientId,
                RiskProfile: riskprofile,
                TaskType: medImage,
                Task: Task,
                notes: "notes",
                shiftPeriod: taskDoneShiftPeriod,
                taskTime: task.schedule?.[0] ?? globalTask?.schedule?.[0],
                timeDone: taskDoneTime,
                taskStatus: taskStatus,
                bgColor: bgColor,
                shiftId: shiftItem._id,
                date: shiftItem?.Date,
                dateToShort: combinedDateTime,
                careteamName,
                description: taskDescription,
                observations: taskObservation,
                checkoutByPerson: task?.checkoutByPerson,
              };
              if (task?.shiftTiming && task?.status === "In-Process") {
                medTaskObj.shiftPeriod = task?.shiftTiming;
              }
              tasksArr.push(medTaskObj);
            } else if (isWellbeing) {
              const wellbeingObj = {
                _id: task._id,
                id: `${task?._id}${index}_${taskIndex}task`,
                clientName: clientName,
                clientId: clientId,
                RiskProfile: "",
                TaskType: "/admin/images/s9.svg",
                Task: "Wellbeing",
                notes: "notes",
                shiftPeriod: taskDoneShiftPeriod,
                taskTime: taskStartTime
                  ? `${taskStartTime} - ${taskEndTime}`
                  : "00:00 - 23:59",
                timeDone: taskDoneTime,
                taskStatus: taskStatus,
                bgColor,
                shiftId: shiftItem._id,
                date: shiftItem?.Date,
                dateToShort: task?.timestamp ?? combinedDateTime,
                careteamName,
                description: taskDescription,
                observations: taskObservation,
                checkoutByPerson: task?.checkoutByPerson,
              };
              if (task?.shiftTiming && task?.status === "In-Process") {
                wellbeingObj.shiftPeriod = task?.shiftTiming;
              }
              tasksArr.push(wellbeingObj);
            } else {
              let taskObj = {
                _id: task?._id,
                id: `${task?._id}${index}_${taskIndex}task`,
                clientName: clientName || "",
                clientId,
                RiskProfile: riskprofile,
                TaskType: taskName[0]?.image || "",
                Task: globalTask?.taskType || "",
                notes: "notes",
                shiftPeriod: taskDoneShiftPeriod,
                taskTime: taskStartTime
                  ? `${taskStartTime} - ${taskEndTime}`
                  : "00:00 - 23:59",
                timeDone: taskDoneTime,
                taskStatus: taskStatus || "",
                bgColor: bgColor,
                shiftId: shiftItem._id,
                date: taskDate,
                dateToShort: task?.timestamp ?? combinedDateTime,
                careteamName,
                description: taskDescription,
                observations: taskObservation,
                checkoutByPerson: task?.checkoutByPerson,
              };
              if (task?.shiftTiming && task?.status === "In-Process") {
                taskObj.shiftPeriod = task?.shiftTiming;
              }
              tasksArr.push(taskObj);
            }
          });
        }
      });
    });

    let combinedArr = [...checkInOutArr, ...tasksArr];
    const sortedArr = combinedArr.sort(compareDates);
    setRowData(sortedArr);
  }

  const compareDates = (a, b) => {
    const dateA = moment(a.dateToShort);
    const dateB = moment(b.dateToShort);

    if (!dateA.isValid() || !dateB.isValid()) {
      // Handle invalid dates
      return 0; // Leave them in the same order
    }

    if (dateA.isBefore(dateB)) {
      return 1; // Swap if dateA is before dateB
    } else if (dateA.isAfter(dateB)) {
      return -1; // Don't swap if dateA is after dateB
    }

    return 0; // Leave them in the same order
  };

  function removeDuplicates(array) {
    const uniqueEntries = [];
    const uniqueMap = new Map();

    for (const entry of array) {
      const key = `${entry.clientId}_${entry.date}_${entry.Task}`;

      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, true);
        uniqueEntries.push(entry);
      }
    }

    return uniqueEntries;
  }

  // -----------  Delete Shift Popup (Show and Hide Handler) Starts ------------ //

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const handleCloseDeletePopup = () => setIsDeleteOpen(false);
  const handleShowDeletePopup = () => setIsDeleteOpen(true);

  // ---------------------     delete multiple  api    ----------------------------------  //

  async function deletemultiple() {
    const res = await httpAdmin(
      "deleteTask",
      "post",
      { ids: selectedIds },
      null
    );
    if (res.status) {
      handleCloseDeletePopup();
      getShiftsandtaskData();
    }
    ShowSwal(res.status, res.message);
  }

  function selectShiftTasks(ids) {
    const arrayOfIds = rowData
      .filter((item) => ids.includes(item.id))
      .map((item) => ({ shiftId: item.shiftId, taskId: item.id }));
    setSelectedIds(arrayOfIds);
  }

  // -----------  Change Shift Status Popup (Show and Hide Handler) Starts ------------ //

  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const handleCloseStatusPopup = () => setIsStatusOpen(false);
  const handleShowStatusPopup = () => setIsStatusOpen(true);

  // --------------------- change the friends and family status (api) ------------------------- //

  async function changeShiftTaskStatus({ taskStatus }) {
    const body = selectedIds?.map((item) => ({
      ...item,
      status: taskStatus.value,
    }));
    const res = await httpAdmin("markTaskStatus", "post", { ids: body }, null);
    if (res.status) {
      getShiftsandtaskData();
      handleCloseStatusPopup();
    }
    ShowSwal(res.status, res.message);
  }

  function customDateChangeHandler(update) {
    setDateRange(update);
  }

  function handleTaskReload(val) {
    setReloadData(val);
  }

  const handleNavigate = (type) => {
    if (type === "task-status") setReloadData((prev) => prev + 1);
    history.replace({
      pathname: `${url}/${type}`,
    });
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="container-fluid min_height">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <ul
                    className="nav nav-tabs ract_tab_list border-0 listspaceGap"
                    id="myTab"
                    role="tablist"
                  >
                    <li className="nav-item me-3" role="presentation">
                      <p
                        onClick={() => handleNavigate("schedule")}
                        className={`nav-link curser_point ${
                          window.location.href.includes("schedule")
                            ? "active"
                            : ""
                        }`}
                      >
                        Schedule
                      </p>
                    </li>

                    <li className="nav-item" role="presentation">
                      <p
                        onClick={() => handleNavigate("task-status")}
                        className={`nav-link curser_point ${
                          window.location.href.includes("task-status")
                            ? "active"
                            : ""
                        }`}
                      >
                        Task Status
                      </p>
                    </li>
                  </ul>
                </div>
                <div
                  className="col-md-3 searchForm searchFormResponsive"
                  style={{ marginLeft: "0px" }}
                >
                  <input
                    type="text"
                    className="form-control"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                    placeholder="search"
                  />
                  <BsSearch className="icon me-2" />
                </div>
                {window.location.href.includes("task-status") && (
                  <div className="col-md-5">
                    <div className="col-md-12 dateFilter_sales dateFilter_salesPayroll">
                      <div className="">
                        <ul className="filter_box d-sm-flex d-md-flex d-lg-block">
                          {/* <NavLink
                          exact
                          activeClassName={filterType === "today" ? "active" : ""}
                          to="#"
                          onClick={() => setFilterType("today")}
                        >
                          Today
                        </NavLink> */}
                          <NavLink
                            activeClassName={
                              filterType === "week" ? "active mx-3" : "mx-3"
                            }
                            to="#"
                            onClick={() => setFilterType("week")}
                          >
                            This Week
                          </NavLink>
                          <NavLink
                            activeClassName={
                              filterType === "custom" ? "active" : ""
                            }
                            to="#"
                            onClick={() => setFilterType("custom")}
                          >
                            Custom
                          </NavLink>
                        </ul>
                      </div>
                      {filterType === "custom" ? (
                        <div className="input_space">
                          <DatePicker
                            selectsRange={true}
                            dateFormat="dd/MM/yyyy"
                            startDate={startDate}
                            endDate={endDate}
                            maxDate={new Date()}
                            onChange={(update) => {
                              customDateChangeHandler(update);
                            }}
                            isClearable={true}
                          />
                        </div>
                      ) : (
                        <div className="input_space">&ensp;</div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="tab-content" id="myTabContent">
                <Switch>
                  <Route path={`${path}/:topicId`}>
                    <RotaRoutes
                      selectShiftTasks={selectShiftTasks}
                      searchText={searchText}
                      rowData={rowData}
                    />
                  </Route>
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* delete Shift tasks */}
      <Modal
        className="viewModal"
        show={isDeleteOpen}
        onHide={handleCloseDeletePopup}
      >
        <Modal.Header>
          <Modal.Title>
            <span>Delete Task</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="">
                <p>
                  Are you sure you want to delete this{" "}
                  {selectedIds?.length > 1 ? "tasks" : "task"} ?
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex">
            <button className="btn submitBtn" onClick={handleCloseDeletePopup}>
              No
            </button>
            <button
              className="btn submitBtn"
              onClick={() => {
                deletemultiple();
              }}
            >
              Yes
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* change shift tasks status */}
      <Modal
        className="viewModal"
        show={isStatusOpen}
        onHide={handleCloseStatusPopup}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <span>Change Task Status</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12 mb-3">
              <label className="form-label">Status</label>
              {/* React Select Along with React Hook Form */}
              <Select
                isClearable
                isSearchable={false}
                className="react-dropdown"
                classNamePrefix="dropdown"
                options={ShiftTaskStatus}
                // onChange={handleStatusChange}
              />
              <p className="error_style"></p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex">
            <button
              type="button"
              className="btn submitBtn"
              onClick={handleCloseStatusPopup}
            >
              Close
            </button>
            <button
              type="submit"
              className="btn submitBtn"
              onClick={changeShiftTaskStatus}
            >
              Update
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Shift;

function uniqueByDate(arr) {
  const seen = new Set();
  return arr.filter((item) => {
    if (seen.has(item.Date)) return false;
    seen.add(item.Date);
    return true;
  });
}
